// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_CAT_CLOTHING = "Oble\u010denie";
export const BZ2_CAT_FOOTWEAR = "Obuv";
export const BZ2_CAT_HOME_LIVING = "Dom\u00e1cnos\u0165";
export const BZ2_CAT_PRAMS = "Ko\u010d\u00edky";
export const BZ2_CAT_TOYS = "Hra\u010dky a hry";
export const HOMEPAGE_MORE_CATEGORIES = "\u010eal\u0161ie kateg\u00f3rie";
export const HOMEPAGE_MORE_CATEGORIES_SHORT = "\u010eal\u0161ie";
export const HOME_SHOW_PRODUCTS_FROM_location = "Inzer\u00e1ty v %(location)s";
export const HOME_SHOW_PRODUCTS_FROM_YOUR_LOCATION = "Pozri si inzer\u00e1ty z tvojej obce";
